module.exports = __webpack_public_path__ + "img/cover.905edb1a.jpg";